module.exports = __webpack_public_path__ + "static/img/xi_2.e136062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_2.png
// module id = Aquc
// module chunks = 1